/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkRetrieveUsersResponse } from '../../models/bulk-retrieve-users-response';

export interface UsersBulkRetrievePost$Params {
  'Active-Tenant-Identifier': string;
      body: Array<string>
}

export function usersBulkRetrievePost(http: HttpClient, rootUrl: string, params: UsersBulkRetrievePost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: BulkRetrieveUsersResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, usersBulkRetrievePost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: BulkRetrieveUsersResponse;
      }>;
    })
  );
}

usersBulkRetrievePost.PATH = '/users/bulk-retrieve';
